import React from 'react';

function Home() {
  return (
    <div>
      <h1>NBHWC Study platform</h1>
      <p>let's get studying!</p>
    </div>
  );
}

export default Home;
